import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class GoalCollectionsSubCategories extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'GoalCollectionsSubCategories'
  // Define default properties here
  static instanceDefaults () {
    return {
      title: null,
      description: null,
      rating: 0.0,
      goalCollectionId: null,
      subCategoryId: null,
    }
  }
}
const servicePath = 'goal-collections-sub-categories'
const servicePlugin = makeServicePlugin({
  Model: GoalCollectionsSubCategories,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
